import React from "react";
import { pushGtmEvent } from "@/lib/gtm";
import { waLink, LP_WA_MESSAGE } from "./lpData";

const LpHeader = () => (
  <header className="sticky top-0 z-50 bg-black border-b border-white/10" data-testid="lp-header">
    <div className="aevos-container flex h-16 items-center justify-between">
      <img
        src="/assets/aevos-horizontal-light-v2.svg"
        alt="AEVOS — Ciência que multiplica vida"
        className="h-8 md:h-9 w-auto"
        draggable={false}
      />
      <a
        href={waLink(LP_WA_MESSAGE)}
        target="_blank"
        rel="noreferrer"
        className="btn-lp-green !py-2.5 !px-4 text-xs md:text-sm"
        data-testid="lp-header-cta"
        onClick={() => pushGtmEvent("whatsapp_click", { location: "lp_header" })}
      >
        Agendar consulta
      </a>
    </div>
  </header>
);

export default LpHeader;
